import React, { useState } from "react";
import api, { formatApiErrorDetail as fmtErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

// mode: "approve" | "reject" | "close"; kind: "leaves" | "reimbursements"
export default function DecisionDialog({ item, kind, mode, onClose, onDone }) {
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const title = mode === "close" ? "Close reimbursement" : `${mode === "approve" ? "Approve" : "Reject"} request`;

  const submit = async () => {
    setLoading(true);
    try {
      if (mode === "close") await api.post(`/reimbursements/${item.id}/close`, { note });
      else await api.post(`/${kind}/${item.id}/decision`, { action: mode, note });
      toast.success(mode === "close" ? "Closed — requester notified" : `Request ${mode === "approve" ? "approved" : "rejected"} — requester notified`);
      onDone?.(); onClose();
    } catch (e) { toast.error(fmtErr(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="decision-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{title}</DialogTitle>
          <DialogDescription>{item.user_name} will get an in-app notification and an email.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label>Note (optional)</Label>
          <Textarea value={note} onChange={(e) => setNote(e.target.value)}
            placeholder={mode === "close" ? "e.g. Paid via bank transfer on Oct 10" : "Add a note for the requester"} data-testid="decision-note-input" />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button onClick={submit} disabled={loading} data-testid="decision-confirm-button"
            className={mode === "reject" ? "bg-red-600 hover:bg-red-700" : mode === "close" ? "bg-slate-900 hover:bg-slate-800" : "bg-emerald-600 hover:bg-emerald-700"}>
            {loading ? "Saving…" : mode === "close" ? "Close & notify" : mode === "approve" ? "Approve" : "Reject"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
